import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, Input } from 'reactstrap';
import { createSelector } from 'reselect';
import { toggleDuplicateNewSizeCreativeModal } from '../../../../../slices/modals/reducer';
import { duplicateCreativeWithResize, updateVersionStatusAfterUpdate } from '../../../../../slices/campaigns/thunk';

function DuplicateNewSizeCreative() {
  const dispatch = useDispatch();
  const selectStates = createSelector(state => state, state => ({
    modalState: state.Modal.duplicateNewSizeCreativeModal,
    creativeToBeDuplicate: state.Campaign.duplicateCreative,
  }));
  const { modalState, creativeToBeDuplicate } = useSelector(selectStates);
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    if (creativeToBeDuplicate) {      
      setWidth(Number(creativeToBeDuplicate.size.split('x')[0]))
      setHeight(Number(creativeToBeDuplicate.size.split('x')[1]))
    }
  }, [creativeToBeDuplicate]);

  function handleWidthChange(e) {
    setWidth(e.target.value);
  }

  function handleHeightChange(e) {
    setHeight(e.target.value);
  }

  async function handleSubmit() {
    dispatch(duplicateCreativeWithResize(creativeToBeDuplicate._id, width, height));
  }

  return (
    <Modal isOpen={modalState} toggle={() => dispatch(toggleDuplicateNewSizeCreativeModal())} centered size='sm'>
      <ModalHeader className='p-3' toggle={() => dispatch(toggleDuplicateNewSizeCreativeModal())}>Duplicate With Resize</ModalHeader>
      <ModalBody className='d-flex flex-row flex-nowrap gap-2 px-3'>
        <div className='w-100'>
          <Label htmlFor='width'>
            Width
          </Label>
          <Input type='number' name='width' onChange={handleWidthChange} value={(width)} />
        </div>
        <div className='w-100'>
          <Label htmlFor='height'>
            Height
          </Label>
          <Input type='number' name='height' onChange={handleHeightChange} value={(height)} />
        </div>
      </ModalBody>
      <ModalFooter className='px-3'>
        <button className='btn btn-light' onClick={() => dispatch(toggleDuplicateNewSizeCreativeModal())}>Close</button>
        {width && height ?
          <button className='btn btn-success' onClick={handleSubmit}>Duplicate</button>
          : null}
      </ModalFooter>
    </Modal>
  )
}

export default DuplicateNewSizeCreative
